<template>
  <div class="d-flex flex-row align-items-end">

    <div class="image-preview-container" :style="{ backgroundImage: `url(${imagePreview})` }">
      <span v-if="!selectedImage"> + </span>
    </div>
    <div class="ml-4 d-flex flex-column align-self-center">
      <div class="d-flex flex-column">
        <span>Select from Media Library</span>
        <span>(Max Dimension 1200 x 800 px)</span>
      </div>

      <div v-show="selectImgBtn" class="align-self-start">
        <button class="btn btn-block btn-gray" @click="handleClick" >Browse...</button>
      </div>
    </div>
    
  </div>
</template>

<script>
import SmallButtonComponent from '@/components/SmallButtonComponent.vue';
import Primary from './PrimaryButton.vue';

export default {
  inheritAttrs: false,
  components: {SmallButtonComponent, Primary},
  props: {
    data: {
      type: Object,
      required: false,
      default: ({ image_url: null })
    },
    selectedImage: {
      type: String,
      required: false,
      default: ''
    },
    dataTitle: {
      type: String,
      required: false,
      default: 'Select Image'
    },

    selectImgBtn: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
    };
  },
  computed: {
    imagePreview() {
      return this.selectedImage
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    }
  },
  beforeUnmount() {
    if (this.selectedFile) {
      URL.revokeObjectURL(this.imagePreview);
    }
  },
};
</script>

<style>
.image-preview-container {
  width: 380px;
  height: 350px;
  border: 1px solid #ccc;
  background-color: #f0f0f0;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 14px;
  color: #666;
}
</style>